import { jsx as m } from "react/jsx-runtime";
import t from "react";
import a from "../../_virtual/index.es.js";
import "../stitches.config.es.js";
import { loader as s } from "./Spinner.styles.es.js";
const p = ({
  className: r,
  spinnerSize: o = "normal",
  sx: e,
  ...i
}) => /* @__PURE__ */ m("div", { "aria-busy": "true", "aria-live": "polite", ...i, className: a(s({
  size: o,
  css: e
}), r) }), u = t.memo(p);
export {
  u as default
};
//# sourceMappingURL=Spinner.es.js.map
